import IngredientList from './IngredientList'
export {IngredientList}
export default IngredientList
